var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsleEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5005 0C19.1279 0 24.5005 5.37258 24.5005 12H0.500488C0.500488 5.37258 5.87307 0 12.5005 0Z",
    fill: "#9499A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 3.5C17.1944 3.5 21 7.30558 21 12H4C4 7.30558 7.80558 3.5 12.5 3.5Z",
    fill: "#B2B7BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5005 7.5C14.9858 7.5 17.0005 9.51472 17.0005 12H8.00049C8.00049 9.51472 10.0152 7.5 12.5005 7.5Z",
    fill: "#D8DFE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.47144 13.5H11.0459C11.4342 13.5 11.749 13.8163 11.749 14.2065C11.749 14.3616 11.6982 14.5124 11.6044 14.6357L6.62001 21.1853C6.35234 21.537 5.85161 21.6041 5.50159 21.3351C5.4455 21.292 5.39536 21.2416 5.35247 21.1853L0.699034 15.0706C0.372818 14.6419 0.454187 14.0287 0.880778 13.7009C1.05037 13.5706 1.25794 13.5 1.47144 13.5Z",
    fill: "#9499A1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9536 13.5H23.5281C24.0651 13.5 24.5005 13.9374 24.5005 14.4771C24.5005 14.6916 24.4302 14.9002 24.3005 15.0706L19.6471 21.1853C19.3794 21.537 18.8787 21.6041 18.5287 21.3351C18.4726 21.292 18.4224 21.2416 18.3795 21.1853L13.3951 14.6357C13.1592 14.3257 13.2181 13.8823 13.5265 13.6453C13.6492 13.5511 13.7992 13.5 13.9536 13.5Z",
    fill: "#9499A1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00146 13.5H21.0015L13.1741 23.6684C12.887 24.0413 12.3532 24.11 11.9817 23.8219C11.9245 23.7775 11.8731 23.7259 11.8289 23.6684L4.00146 13.5Z",
    fill: "#B2B7BE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50146 13.5H16.5015L12.7799 18.3627C12.6627 18.5158 12.4431 18.5453 12.2893 18.4287C12.2644 18.4098 12.2421 18.3876 12.2231 18.3627L8.50146 13.5Z",
    fill: "#D8DFE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsleEmpty);
export default __webpack_public_path__ + "static/media/isle_empty.560fe2087d82c33b4426ba0ea964cce1.svg";
export { ForwardRef as ReactComponent };